<template>
  <div>
    <v-btn 
      text 
      @click="clearFilter()" 
      class="text-body-2 text-none no-hover"
      :ripple="false"
    >
      {{ $t('clear') }}
    </v-btn>
    <v-menu
      v-model="filterMenu"
      :close-on-content-click="false"
      width="360"
      max-width="360"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="rounded-xxl text-none px-4"
          data-testid="date-filter-button"
        >
          {{ shownDate == '' ? $t('loginStatus') : shownDate }}
          <v-icon
            right
            color="accent"
          >
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item data-testid="date-filter-specific-date" class="mt-3">
          <v-menu
            ref="menu"
            v-model="startDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                color="accent"
                v-model="startDateSelected"
                v-bind="attrs"
                v-on="on"
                readonly
                clearable
                data-testid="date-input"
                class="mr-3 pa-0 set-date-filter"
                max-width="100px"
                hide-details
              >
                <template v-slot:prepend-inner>
                  <v-icon color="accent">mdi-calendar</v-icon>
                </template>
                <template v-slot:label>
                  <div>
                    <span
                      class="text-subtitle-2 accent--text"
                      >{{ $t("startDate") }}</span
                    >
                  </div>
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="startDateSelected" no-title @input="startDateMenu = false">
            </v-date-picker>
          </v-menu>
          <v-menu
            ref="menu"
            v-model="endDateMenu"
            :close-on-content-click="false"
            :nudge-left="140"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                color="accent"
                v-model="endDateSelected"
                v-bind="attrs"
                v-on="on"
                readonly
                clearable
                data-testid="date-input"
                class="pa-0 set-date-filter"
                max-width="100px"
                hide-details
              >
                <template v-slot:prepend-inner>
                  <v-icon color="accent">mdi-calendar</v-icon>
                </template>
                <template v-slot:label>
                  <div>
                    <span
                      class="text-subtitle-2 accent--text"
                      >{{ $t("endDate") }}</span
                    >
                  </div>
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="endDateSelected" no-title @input="endDateMenu = false">
            </v-date-picker>
          </v-menu>
          <v-icon @click="setSpecificDate" color="accent" data-testid="date-filter-specific-date-apply">mdi-chevron-right</v-icon>
        </v-list-item>
        <v-list-item data-testid="date-filter-this-month" @click="setDate(0), shownDate = $t('filterThisMonth')">
          <v-list-item-title>{{ $t('filterThisMonth') }}</v-list-item-title>
        </v-list-item>
        <v-list-item data-testid="date-filter-last-3-months" @click="setDate(3), shownDate = $t('filterLastThreeMonths')">
          <v-list-item-title>{{ $t('filterLastThreeMonths') }}</v-list-item-title>
        </v-list-item>
        <v-list-item data-testid="date-filter-last-6-months" @click="setDate(6), shownDate = $t('filterLastSixMonths')">
          <v-list-item-title>{{ $t('filterLastSixMonths') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import moment from 'moment'
import i18n from '../plugins/i18n'

export default {
    mixins: [repeatedMethodsMixin],
     props: {
  },
  data: function() {
    return { 
      startDateSelected: null,
      endDateSelected: null,
      startDateMenu: false,
      endDateMenu: false,
      filterMenu: false,
      startDate: null,
      endDate: null,
      shownDate: ''
    }
  },
  methods: {
    setDate(months){
      this.filterMenu = false
      this.startDateSelected = null
      this.endDateSelected = null

      if(months == 0){
        this.startDate = new Date()
        this.startDate = moment(new Date(this.startDate.getFullYear(), this.startDate.getMonth(), 1)).format('YYYY-MM-DD')
        
      }else {
        this.startDate = new Date()
        this.startDate = moment(this.startDate.setMonth(this.startDate.getMonth() - months)).format('YYYY-MM-DD')
      }
      
      this.$emit('dateFilter', this.startDate, this.endDate)
    },
    setSpecificDate(){
      this.filterMenu = false
      this.startDate = this.startDateSelected
      this.endDate = this.endDateSelected
      this.shownDate = this.startDate + ' - ' + this.endDate
      
      if(this.startDate == null && this.endDate == null){
        this.shownDate = ''
      }else if(this.startDate == null && this.endDate != null){
        this.shownDate =  i18n.t('until') + ' ' + this.endDate
      }else if(this.startDate != null && this.endDate == null){
        this.shownDate = i18n.t('from') + ' ' + this.startDate
      }else{
        this.shownDate = this.startDate + ' - ' + this.endDate
      }

      this.$emit('dateFilter', this.startDate, this.endDate)     
    },

    clearFilter(){
      this.startDateSelected = null
      this.endDateSelected = null
      this.startDate = null
      this.endDate = null
      this.shownDate = ''

      this.$emit('dateFilter', this.startDate, this.endDate)
    }
  },
}
 
</script>